import React from "react";

/**
 * Chat actions component with buttons for PRD, Preview, and Download
 * @param {Object} props
 * @param {string|null} props.currentSessionId - Current session ID
 * @param {boolean} props.isStartingSession - Whether a session is being started
 * @param {Function} props.onStartSession - Handler for starting a new session
 * @param {Function} props.onOpenPRD - Handler for opening PRD panel
 * @param {Function} props.onOpenPreview - Handler for opening preview panel
 * @param {Function} props.onDownloadEWA - Handler for downloading EWA
 */
const ChatActions = ({
  currentSessionId,
  isStartingSession,
  onStartSession,
  onOpenPRD,
  onOpenPreview,
  onDownloadEWA,
}) => {
  return (
    <div className="chat-actions">
      {!currentSessionId ? (
        <button
          className="generate-ewa-button"
          onClick={onStartSession}
          disabled={isStartingSession}
        >
          {isStartingSession ? (
            <>
              <span className="spinner"></span>
              Starting Chat...
            </>
          ) : (
            <>💬 Start Chat Session</>
          )}
        </button>
      ) : (
        <div className="button-group">
          <button
            className="panel-toggle-button"
            onClick={onOpenPRD}
            title="Product Requirements Document"
          >
            📝 PRD
          </button>
          <button className="panel-toggle-button" onClick={onOpenPreview}>
            👁️ Preview
          </button>
          <button className="load-ewa-button" onClick={onDownloadEWA}>
            🚀 Download EWA
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatActions;
